
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/nearby-areas",
      function () {
        return require("private-next-pages/team/nearby-areas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/nearby-areas"])
      });
    }
  